const routes = [
  {
    path: '/administracao/usuario',
    name: 'user',
    component: () => import('@/views/administracao/usuario/Usuario.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios' }] },
  },
  {
    path: '/administracao/usuario/novo',
    name: 'userNew',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/usuario/:id/editar',
    name: 'userUpdate',
    component: () => import('@/views/administracao/usuario/UsuarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos',
    name: 'userGroup',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioPai.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/novo',
    name: 'userGroupNew',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      requiredPermission: 'user.edit',
      breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Grupos' }, { title: 'Novo' }],
    },
  },
  {
    path: '/administracao/usuario/:idUser/grupos/:id/editar',
    name: 'userGroupUpdate',
    component: () => import('@/views/administracao/usuario/grupoUsuario/GrupoUsuarioNew.vue'),
    meta: {
      requiredPermission: 'user.edit',
      breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Grupos' }, { title: 'Editar' }],
    },
  },
  {
    path: '/administracao/usuario/:idUser/alocacoes',
    name: 'userAllocation',
    component: () => import('@/views/administracao/usuario/alocacaoUsuario/AlocacaoUsuarioPai.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Usuarios', name: 'user' }, { title: 'Alocacao' }] },
  },
  {
    path: '/administracao/grupo',
    name: 'group',
    component: () => import('@/views/administracao/grupo/Grupo.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Grupos' }] },
  },
  {
    path: '/administracao/grupo/novo',
    name: 'groupNew',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Grupos' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/grupo/:id/editar',
    name: 'groupUpdate',
    component: () => import('@/views/administracao/grupo/GrupoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Grupos' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/grupo/:id_group/regras',
    name: 'acl',
    component: () => import('@/views/administracao/grupo/acl/AclPai.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Grupos' }, { title: 'ACL' }] },
  },
  {
    path: '/administracao/programa',
    name: 'screen',
    component: () => import('@/views/administracao/programa/Programa.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Programa' }] },
  },
  {
    path: '/administracao/programa/novo',
    name: 'screenNew',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Programa' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/programa/:id/editar',
    name: 'screenUpdate',
    component: () => import('@/views/administracao/programa/ProgramaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Programa' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/log-acesso-usuario',
    name: 'userAccessLog',
    component: () => import('@/views/administracao/logAcesso/LogAcessoUsuario.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Logs de Acesso' }] },
  },
  {
    path: '/administracao/turno',
    name: 'workShift',
    component: () => import('@/views/administracao/turno/Turno.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Turnos' }] },
  },
  {
    path: '/administracao/turno/novo',
    name: 'workShiftNew',
    component: () => import('@/views/administracao/turno/TurnoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Turnos', name: 'workShift' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/turno/:id/editar',
    name: 'workShiftUpdate',
    component: () => import('@/views/administracao/turno/TurnoNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Turnos', name: 'workShift' }, { title: 'Editar' }] },
  },
  {
    path: '/administracao/escala',
    name: 'workSchedule',
    component: () => import('@/views/administracao/escala/Escala.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Escalas' }] },
  },
  {
    path: '/administracao/escala/novo',
    name: 'workScheduleNew',
    component: () => import('@/views/administracao/escala/EscalaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Escalas', name: 'workSchedule' }, { title: 'Novo' }] },
  },
  {
    path: '/administracao/escala/:id/editar',
    name: 'workScheduleUpdate',
    component: () => import('@/views/administracao/escala/EscalaNew.vue'),
    meta: { breadcrumb: [{ title: 'Administracao' }, { title: 'Escalas', name: 'workSchedule' }, { title: 'Editar' }] },
  },
]

export default routes
